"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
function MicrophoneOff({ className, ...rest }) {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", className: `${className != null && className}`, "data-icon": "microphone-off", focusable: "false", role: "img", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" },
        react_1.default.createElement("title", null, rest.title),
        react_1.default.createElement("line", { x1: "2", x2: "22", y1: "2", y2: "22" }),
        react_1.default.createElement("path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2" }),
        react_1.default.createElement("path", { d: "M5 10v2a7 7 0 0 0 12 5" }),
        react_1.default.createElement("path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33" }),
        react_1.default.createElement("path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12" }),
        react_1.default.createElement("line", { x1: "12", x2: "12", y1: "19", y2: "22" })));
}
exports.default = MicrophoneOff;
//# sourceMappingURL=MicrophoneOff.js.map